{
  "name": "deal-library",
  "type": "module",
  "version": "0.0.1",
  "scripts": {
    "start-mock-server": "node ./src/api/mock-server/server.js"
  },
  "private": true,
  "dependencies": {
    "@openx/components-core": "*",
    "@openx/components-package": "*",
    "@openx/components-table": "*",
    "@openx/components-targeting": "*",
    "@openx/constants": "*",
    "@openx/types": "*",
    "@openx/unit-test-utils": "*",
    "@openx/utils": "*"
  }
}
